module.exports = __webpack_public_path__ + "static/media/syringe.8b5ed29a.svg";